<template>
  <main class="m-trial-page">
    <section class="trial">
      <v-container v-if="renderNow" class="wide-container">
        <h2 class="ml-10">Active Trials</h2>
        <grid-col :columns="columns">
          <trial-card
            v-for="(trial, i) in trialsList"
            :trial="trial"
            :key="trial.id"
            :trial-image="trialImage(i)"
          ></trial-card>
        </grid-col>
      </v-container>
      <v-container v-else style="min-height: 60vh; display: flex; justify-content: center; align-items: center">
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </v-container>
    </section>
  </main>
</template>

<script>
import GridCol from "../components/GridCol";
import TrialCard from "@/components/TrialCard";
import axios from "axios";

export default {
  name: "AdTrialList",
  components: {
    TrialCard,
    GridCol
  },
  metaInfo: {
    title: "Zeda - Trial List",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content: "This is the page that shows the trial list."
      }
    ]
  },
  data() {
    return {
      columns: "auto",
      selectedType: undefined,
      trialsList: [],
      renderNow: false
    };
  },
  methods: {
    getTrialsListFromBackend() {
      let API_URL = process.env.VUE_APP_API_URL + "trials";
      axios(API_URL, {
        method: "GET",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          this.trialsList = response.data;
          this.renderNow = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchTrials() {
      if (!this.selectedType) return;
      try {
        this.$store.dispatch("listTrials", { type: this.selectedType });
      } catch (e) {
        alert(e);
      }
    },
    trialImage(index) {
      if (index % 2 === 0) return require("@/assets/ad-trial/trials_image.jpg");
      else return require("@/assets/ad-trial/trials_image_2.jpg");
    }
  },
  async created() {
    this.getTrialsListFromBackend();
  },
  computed: {
    trials() {
      return this.$store.getters["trials"];
    }
  }
};
</script>

<style lang="scss">
.wide-container {
  max-width: 1100px !important;
}
.trial {
  background-color: #ffff;
}
.m-trial-page {
  margin-top: 20px;
  //min-height: 80vh;
}
.search-bar {
  max-width: 600px;
}
</style>
